export const environment = {
	production: true,
	apiUrl: 'https://ticketing-customer-live.azurewebsites.net',
	coreUrl: 'https://tickets-api.stadium-360.net',
	DataIntegrityKey: 'E7aVEc5y9s34LaUQ'
};
